import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              Hi, I'm <b className="purple">Kartikeya Pandey</b> from Pune,
              Maharashtra, India.
              <br />
              <br />I work on building scalable AI systems and models—especially
              around transformers and NLP.
              <br />
              <br />I am fluent in languages like
              <i>
                <b className="purple"> Python, C++, and JavaScript. </b>
              </i>
              <br />
              <br />My interests include <b className="purple">LLMs</b>,
              <b className="purple"> research on efficient transformers</b>, and
              building production backends with <b className="purple">FastAPI</b>.
            </p>
            <p style={{ marginTop: 12 }}>
              <strong>Contact:</strong> kartikeyapandey20@gmail.com • +91
              9662472123
              <br />
              <strong>GitHub:</strong>{" "}
              <a href="https://github.com/kartikeyapandey20" target="_blank" rel="noreferrer">github.com/kartikeyapandey20</a>
              {" "}| <strong>LinkedIn:</strong>{" "}
              <a href="https://www.linkedin.com/in/kartikeyapandey20" target="_blank" rel="noreferrer">linkedin.com/in/kartikeyapandey20</a>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/kartikeyapandey20"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://x.com/Kartikeya200220"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                    href="https://www.linkedin.com/in/kartikeyapandey20"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/kartikeyapandey20/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
